export default __webpack_public_path__ + "static/warehouse-management-system-0cb50a85699c3346ec0eda75321de88a.png";